import { useTranslation } from 'react-i18next'
import * as SelectPrimitive from '@radix-ui/react-select'
import { apiCallable } from '@/lib/api'
import {
  Select,
  SelectContent,
  SelectItem,
} from '@/components/ui/select'
import { Languages } from 'lucide-react'

const LANGUAGES = [
  { code: 'en', label: 'EN' },
  { code: 'pt-BR', label: 'PT' },
]

export function LanguageSwitcher() {
  const { i18n } = useTranslation()

  const handleLanguageChange = (lng: string) => {
    i18n.changeLanguage(lng)

    // Persist language to user profile for backend features (Telegram alerts, etc.)
    const updateUserLanguage = apiCallable('updateUserLanguage')
    updateUserLanguage({ language: lng }).catch((err) => {
      console.error('Failed to save language to profile:', err)
    })
  }

  // Use Radix Trigger directly so the icon centers cleanly — the shadcn SelectTrigger
  // bakes in flex + justify-between, which leaves icon-only triggers left-aligned.
  return (
    <Select value={i18n.language} onValueChange={handleLanguageChange}>
      <SelectPrimitive.Trigger
        aria-label="Switch language"
        className="inline-flex h-9 w-9 shrink-0 items-center justify-center rounded-pill border border-ink/15 bg-transparent text-ink outline-none transition hover:border-ink/35 hover:bg-ink/5 hover:text-gold focus-visible:ring-2 focus-visible:ring-gold-soft"
      >
        <Languages className="h-4 w-4" strokeWidth={1.6} />
      </SelectPrimitive.Trigger>
      <SelectContent>
        {LANGUAGES.map((lang) => (
          <SelectItem key={lang.code} value={lang.code}>
            {lang.label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  )
}
